import { SubContent } from '@radix-ui/react-context-menu'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'
import { ContextMenuPortal } from '#src/components/ContextMenu/ContextMenuPortal.tsx'

export interface ContextMenuSubContentProps extends ComponentPropsWithoutRef<
  typeof SubContent
> {
  /**
   * [data-state] - "open" | "closed"
   * [data-side] - "left" | "right" | "bottom" | "top"
   * [data-align] - "start" | "center" | "end"
   */
  className?: string
}

export const ContextMenuSubContent = forwardRef<
  ElementRef<typeof SubContent>,
  ContextMenuSubContentProps
>(({ className, ...delegated }, ref) => (
  <ContextMenuPortal>
    <SubContent
      ref={ref}
      className={cn(
        'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=closed]:animate-out data-[state=open]:animate-in',
        className
      )}
      {...delegated}
    />
  </ContextMenuPortal>
))
ContextMenuSubContent.displayName = SubContent.displayName
